import { PictogramPlaceholderImages40 } from '@cian/ui-kit-design-tokens/pictograms';
import classNames from 'clsx';
import * as React from 'react';

import { useImageOrientation } from './hooks';
import * as styles from './styles.css';
import { IImageFile } from '../../types/imageFile';
import { ChatImageLoader } from '../ChatImageLoader';

interface IChatImageProps {
  src: string;
  image: IImageFile;
  onLoad: () => void;
  onError: () => void;
  onClick: () => void;
  onSave?: () => void;
  isLoading: boolean;
  isError: boolean;
  withSave?: boolean;
  isGalleryItem?: boolean;
}

const ChatImageComponent = function (
  { src, image, onLoad, onError, onClick, isLoading, isError, withSave, isGalleryItem }: IChatImageProps,
  ref: React.Ref<HTMLImageElement>,
) {
  const { name } = image;

  const orientation = useImageOrientation(image);

  return (
    <div
      data-name="ChatImage"
      className={classNames(styles['container'], styles[orientation], isGalleryItem && styles['gallery_item'])}
      onClick={onClick}
    >
      <span className={styles['loader']} data-testid="loader">
        <ChatImageLoader isLoading={isLoading} />
      </span>
      {isError && (
        <div className={styles['error']} data-testid="error">
          <PictogramPlaceholderImages40 color="current_color" />
        </div>
      )}
      {!isError && !withSave && (
        <img
          ref={ref}
          className={styles['image']}
          src={src}
          alt={name}
          loading="lazy"
          onLoad={onLoad}
          onError={onError}
          data-name="ChatImage_img"
        />
      )}
      {!isError && withSave && (
        <a href={src} download data-name="ChatImage_withSave">
          <img
            ref={ref}
            className={styles['image']}
            src={src}
            alt={name}
            loading="lazy"
            onLoad={onLoad}
            onError={onError}
          />
        </a>
      )}
    </div>
  );
};

export const ChatImage = React.forwardRef(ChatImageComponent);
